<template>
	<component
		:is="type"
		:aria-label="ariaLabel"
		:link="link"
		:disabled="disabled"
		:target="target"
		@click="$emit('click')"
	>
		<slot />
	</component>
</template>

<script>
import Internal from './internal/Internal.vue';
import External from './external/External.vue';
import Empty from './empty/Empty.vue';

export default {
	name: 'Link',

	components: {
		Internal,
		External,
		Empty,
	},

	props: {
		ariaLabel: {
			type: String,
			required: false,
			default: '',
			description: 'Can supply an aria-label when no link text is provided',
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false,
			description: 'Disables this helio-link to show empty link and does not emit click event',
		},

		link: {
			type: [String, Object],
			required: false,
			default: null,
			description: 'A string or link value that begins with / will create an internal router-link. A link that doesn\'t begin with / will create an &lt;a&gt; tag',
		},

		target: {
			type: String,
			required: false,
			default: '_self',
			description: 'Sets the location where the linked document will be opened',
		},
	},

	computed: {
		type() {
			if (this.link && !this.disabled) {
				if (
					this.link instanceof Object
					|| this.link.charAt(0) === '/'
				) {
					return 'internal';
				}

				return 'external';
			}

			return 'empty';
		},
	},
};
</script>
